import { shareButtonTemplatesEnum } from '@/components/Shared/SF_SocialShareCard_001/enums/shareButtonTemplatesEnum';

export const getShareButtonTemplate = (templateName) => (pageTitle, pageUrl) => {

    if (templateName in shareButtonTemplatesEnum) {
        return shareButtonTemplatesEnum[templateName](pageTitle, pageUrl);
    }

    return () => null
}